var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#BE68A9",
    fillOpacity: 0.07
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1596 26.87C25.0596 26.86 24.9396 26.86 24.8296 26.87C22.4496 26.79 20.5596 24.84 20.5596 22.44C20.5596 19.99 22.5396 18 24.9996 18C27.4496 18 29.4396 19.99 29.4396 22.44C29.4296 24.84 27.5396 26.79 25.1596 26.87Z",
    stroke: "#BE68A9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4103 20C34.3503 20 35.9103 21.57 35.9103 23.5C35.9103 25.39 34.4103 26.93 32.5403 27C32.4603 26.99 32.3703 26.99 32.2803 27",
    stroke: "#BE68A9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1597 30.56C17.7397 32.18 17.7397 34.82 20.1597 36.43C22.9097 38.27 27.4197 38.27 30.1697 36.43C32.5897 34.81 32.5897 32.17 30.1697 30.56C27.4297 28.73 22.9197 28.73 20.1597 30.56Z",
    stroke: "#BE68A9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3398 36C35.0598 35.85 35.7398 35.56 36.2998 35.13C37.8598 33.96 37.8598 32.03 36.2998 30.86C35.7498 30.44 35.0798 30.16 34.3698 30",
    stroke: "#BE68A9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStu);
export default __webpack_public_path__ + "static/media/stu.43b3b8d85a5ce0b77fb8eb6b7de77e21.svg";
export { ForwardRef as ReactComponent };